import styled from 'styled-components';

const SelectCountryStyled = styled.div`
  width: max-content;
  display: flex;
  align-items: center;
  align-self: stretch;
  padding: 0 8px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border: 1px solid #d9d9d9;
  isolation: isolate;

  .SelectCountry {
    &__select {
      height: 100%;
      padding-left: 4px;
      font-family: inherit;
      border: none;
      cursor: pointer;
      z-index: 1;

      &:focus-visible {
        outline: none;
      }

      &:disabled {
        cursor: default;
        color: #d9d9d9;
      }
    }

    &__option {
    }

    &__flag {
      height: 32px;

      & .Flag {
        width: 30px;
        height: 30px;
      }
    }
  }
`;

export { SelectCountryStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
